import {createApp} from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import PrimeVue from 'primevue/config'
import ToastService from 'primevue/toastservice'

// Import PrimeVue CSS
import './assets/primevue.css'
// Import PrimeIcons CSS (custom fix for font paths)
import './assets/primeicons-fix.css'

// PrimeVue components
import Card from 'primevue/card'
import Button from 'primevue/button'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Dialog from 'primevue/dialog'
import FileUpload from 'primevue/fileupload'
import Textarea from 'primevue/textarea'
import ProgressSpinner from 'primevue/progressspinner'
import TabView from 'primevue/tabview'
import TabPanel from 'primevue/tabpanel'
import InputText from 'primevue/inputtext'
import Password from 'primevue/password'
import Toast from 'primevue/toast'
import InputNumber from 'primevue/inputnumber'
import Checkbox from 'primevue/checkbox'
import Dropdown from 'primevue/dropdown'
import Message from 'primevue/message'
import Tag from 'primevue/tag'

// Create Pinia instance
const pinia = createPinia()

// Create app instance
const app = createApp(App)

// Register PrimeVue components
app.component('Card', Card)
app.component('Button', Button)
app.component('DataTable', DataTable)
app.component('Column', Column)
app.component('Dialog', Dialog)
app.component('FileUpload', FileUpload)
app.component('Textarea', Textarea)
app.component('ProgressSpinner', ProgressSpinner)
app.component('TabView', TabView)
app.component('TabPanel', TabPanel)
app.component('InputText', InputText)
app.component('Password', Password)
app.component('Toast', Toast)
app.component('InputNumber', InputNumber)
app.component('Checkbox', Checkbox)
app.component('Dropdown', Dropdown)
app.component('Message', Message)
app.component('Tag', Tag)

// Use plugins
app.use(router)
app.use(pinia)
app.use(PrimeVue, { ripple: true })
app.use(ToastService)

// Mount app
app.mount('#app')